/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PersonGbSearchStandardRequest { 
    suchbegriff?: string;
    rolle?: PersonGbSearchStandardRequest.RolleEnum;
    offset?: number;
    limit?: number;
}
export namespace PersonGbSearchStandardRequest {
    export type RolleEnum = 'EIGENTUEMER' | 'UEBRIGE_BERECHTIGTE' | 'GLAEUBIGER_SCHULDNER' | 'ALLE';
    export const RolleEnum = {
        EIGENTUEMER: 'EIGENTUEMER' as RolleEnum,
        UEBRIGE_BERECHTIGTE: 'UEBRIGE_BERECHTIGTE' as RolleEnum,
        GLAEUBIGER_SCHULDNER: 'GLAEUBIGER_SCHULDNER' as RolleEnum,
        ALLE: 'ALLE' as RolleEnum
    };
}


